import {
    Box,
    CrudMode,
    Checkbox,
    DataDisplay,
    Grid,
    pn,
    Stack,
    Typography,
    useElementBreakpoints,
    ValidationErrors,
} from "@compass/core";
import { Input } from "components";
import { Lep, LEPEditResource, LEPViewResource } from "generated/openApi";
import produce from "immer";
import React from "react";
export const LEPPageBody = (props: {
    crudMode: CrudMode;
    lep: Lep;
    setLep: (value: Lep) => void;
    viewResource: LEPViewResource;
    editResource: LEPEditResource;
    validationErrors: ValidationErrors;
}) => {
    const { breakpointsRef, smallFieldBreakpoints, largeFieldBreakpoints } = useElementBreakpoints();
    const properties = props.viewResource.properties || [];

    const nameField = () => {
        const propertyName = pn<Lep>("name");
        const property = properties.find((x) => x.propertyName === propertyName);
        return props.crudMode === "view" ? (
            <DataDisplay label={property?.displayName}>{props.lep.name}</DataDisplay>
        ) : (
            <Input
                modelProperty={property}
                errors={props.validationErrors[propertyName]}
                value={props.lep.name}
                onChange={(e) =>
                    props.setLep(
                        produce(props.lep, (draft) => {
                            draft.name = e.target.value;
                        })
                    )
                }
            />
        );
    };

    const isLepField = () => {
        const propertyName = pn<Lep>("isLep");
        const property = properties.find((x) => x.propertyName === propertyName);
        return props.crudMode === "view" ? (
            <DataDisplay label={property?.displayName}>{props.lep.isLep ? "Yes" : "No"}</DataDisplay>
        ) : (
             <Checkbox
                label={property?.displayName}
                checked={props.lep.isLep || false}
                onChange={(e) =>
                    props.setLep(
                        produce(props.lep, (draft) => {
                            draft.isLep = e.target.checked;
                        })
                    )
                }
        />
        );
    };

    return (
        <Grid ref={breakpointsRef} container spacing="sm">
            <Grid item xs={largeFieldBreakpoints}>
                {nameField()}
            </Grid>
            <Grid item xs={largeFieldBreakpoints}>
                {isLepField()}
            </Grid>
        </Grid>
    );
};